import { State } from "../reducers";

export const cartSelector = (state: State) => state.cartReducer;